import axios from "axios";
import { mainBaseUrl } from "@/apis/appconst";

const apiBaseUrl = mainBaseUrl + "api/v1";
import Cookies from "js-cookie";

export async function createStaff(busID, staffDetails) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.post(
      `${apiBaseUrl}/staff`,
      {
        bus_id: busID,
        name: staffDetails.name,
        role: staffDetails.role,
        phone_number: staffDetails.phone_number,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
     success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}
export async function getStaffById(staffId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/staff/${staffId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
     success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function searchStaff(searchKey) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/staff/search`, {
      params: {
        search_key: searchKey, // Pass the search key as a query parameter
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getAllStaff(filters) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/staff`, {
      params: {
        name: filters.name || "",
        role: filters.role || "",
        bus_id: filters.bus_id || "",
        phone_number: filters.phone_number || "",
        page_no: filters.page_no || 1,
        limit: filters.limit || 10,
        ascending: filters.ascending || false,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function updateStaff(staffId, updatedDetails) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.put(
      `${apiBaseUrl}/staff/${staffId}`,
      updatedDetails.staff,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function deleteStaff(staffId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.delete(`${apiBaseUrl}/staff/${staffId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}
